import store from "../../../../store";
import { has, have } from "../../../../utils/menu-context";

const commonInputPropField = ({ disabledStatuses, disabledRequestTypes }) => ({ modelRef, initialModel }) => {
    let enabled = undefined;
    if (disabledStatuses.includes(initialModel.refStatus?.key) || disabledRequestTypes.includes(modelRef.refRequestType?.key)) {
        enabled = false;
    }
    return { disabled: enabled !== undefined ? !enabled : undefined };
};

const isLock = ({ record }) => {
    return !record.refInspectionTemp?.isUnlock
        && record.refInspectionTemp?.refInformTemp?.refInspectionLv?.attribute?.isWaitForDeclaration
        && !record.refInspectionTemp?.refInformTemp?.refTransferDeclaration?.id
};

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (["waitReceive"].includes(record.refStatus?.key) && isLock({ record })) return false;
            if (record.createBy === store.state.resource.auth.info.user?.username
                // || (record.createBy === "anonymousUser" && record.refInspectionTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
                || (record.refInspectionTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canUnlock: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    if (isLock({ record })) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWaitReceive: ({ record }) => {
            let result = false;
            if (
                record.createBy === store.state.resource.auth.info.user?.username ||
                    (record.createBy === "anonymousUser" &&
                        record.refInspectionTemp?.refUser?.username === store.state.resource.auth.info.user?.username)
            ) {
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    if (record.refToApproveBy?.username === userInfo.username) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canReStatus: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["waitReceive"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forReceive" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canReport: ({ record }) => {
            return !["draft"].includes(record.refStatus?.key);
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["refDocGenType", "requestCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refInspectionTemp.refRequestDoc"].includes(field?.key);
            },
            visibleField: () => {
                return true;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refInspectionTemp.approveCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.isOfficerCreate;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return [
                    "refDepartment.nameEn",
                    "lastStatus.waitReceive.0.statusDatetime",
                    "lastStatus.draft.0.statusDatetime",
                    "lastStatus.waitApprove.0.statusDatetime",
                    "refInspectionTemp.refUserCompany.companyNameEn",
                    "refInspectionTemp.refUser.fullNameEn",
                    "refInspectionTemp.refUserCompany.addresses.0.addrTh",
                    "refInspectionTemp.refUserCompany.idCard",
                    "refInspectionTemp.refUser.idCard",
                    "refInspectionTemp.refUser.addresses.0.addrTh"
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refRequestType"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let enabled = false;
                if ([undefined, "draft", "reEditOfficer"].includes(initialModel.refStatus?.key)) {
                    enabled = !viewOnly || enabled;
                }
                return { disabled: !enabled };
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refInspectionTemp.transportDate",
                    "refInspectionTemp.inspectionDatetime",
                    "refInspectionTemp.refInspector",
                    "refInspectionTemp.inspectorTel",
                    "refInspectionTemp.vehicleNo",
                    "refInspectionTemp.containerNo",
                    "refInspectionTemp.sealNo",
                ].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    // "reEditOfficer",
                    // "reEditAuthority",
                    // "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refInspectionTemp.refInformTemp"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["02", "16", "17", "18", "19"].includes(modelRef.refInspectionTemp?.refRequestDoc?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitReceive",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitApprove",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["2", "3", "4"]
            })
        },
        {
            check: ({ field }) => {
                return [
                    "refInspectionTemp.refInformTemp.refTransportByWay2",
                    "refInspectionTemp.refInformTemp.refOriginDestinationCountry2",
                    "refInspectionTemp.refInformTemp.refExportCheckpoint2",
                    "refInspectionTemp.refInformTemp.refImportCheckpoint2",
                    "refInspectionTemp.refInformTemp.refPassCustoms2",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["18", "19"].includes(modelRef?.refInspectionTemp?.refRequestDoc?.key);
            },
        },
        {
            check: ({ field }) => {
                return ["refDepartment", "refInspectionTemp.refUserCompany"].includes(field?.key);
            },
            inputPropField: () => {
                let enabled = false;
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refInspectionTemp.refUser"].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { menuContext } = props;
                let enabled = undefined;
                if (has({ menuContext, key: "forRequest" })) {
                    enabled = false;
                }
                if (![undefined, "draft", "reEditOfficer"].includes(initialModel.refStatus?.key)) {
                    enabled = false;
                }
                if (["2", "3", "4"].includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                return { disabled: enabled !== undefined ? !enabled : undefined };
            }
        },
        {
            check: ({ field }) => {
                return ["refInspection"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2", "3", "4"].includes(modelRef.refRequestType?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let enabled = false;
                if ([undefined, "draft", "reEditOfficer"].includes(initialModel.refStatus?.key)) {
                    enabled = !viewOnly || enabled;
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let enabled = false;
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                    enabled = !viewOnly || enabled;
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forReceiveRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let enabled = false;
                if (["waitReceive"].includes(initialModel.refStatus?.key)) {
                    enabled = !viewOnly || enabled;
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refInspectionTemp.inspectRemark",
                ].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                let result = false;
                const { menuContext } = props;
                if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                    if (![undefined, "draft", "reEditOfficer"].includes(modelRef.refStatus?.key)) {
                        result = true || result;
                    }
                }
                if (["approve"].includes(modelRef.refStatus?.key)) {
                    result = true || result;
                }
                return result;
            },
            inputPropField: ({ props, modelRef }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forRequest" })) {
                    enabled = false;
                }
                if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                    if (!modelRef?.refInspectionTemp?.isInspectRiskValidated
                        && modelRef?.refInspectionTemp?.isInspect) {
                        enabled = !viewOnly || enabled;
                    }
                }
                if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                return { disabled: enabled !== undefined ? !enabled : undefined };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "buttonRiskValidate",
                ].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                let result = false;
                const { menuContext } = props;
                if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                    if (![undefined, "draft", "reEditOfficer"].includes(modelRef.refStatus?.key)) {
                        result = true || result;
                    }
                }
                if (modelRef.refInspectionTemp?.refInformTemp?.refOperation?.key === "3") {
                    return false;
                }
                return result;
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (![undefined, "draft", "reEditOfficer"].includes(initialModel.refStatus?.key)) {
                    enabled = !viewOnly || enabled;
                }
                if (has({ menuContext, key: "forRequest" })) {
                    enabled = false;
                }
                if (modelRef?.refInspectionTemp?.isInspectRiskValidated) {
                    enabled = false;
                }
                if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                return { disabled: enabled !== undefined ? !enabled : undefined };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refInspectionTemp.isInspect",
                ].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                let result = false;
                const { menuContext } = props;
                if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                    if (![undefined, "draft", "reEditOfficer"].includes(modelRef.refStatus?.key)) {
                        result = true || result;
                    }
                }
                if (["approve"].includes(modelRef.refStatus?.key)) {
                    result = true || result;
                }
                return result;
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (![undefined, "draft", "reEditOfficer"].includes(initialModel.refStatus?.key)) {
                    enabled = !viewOnly || enabled;
                }
                if (has({ menuContext, key: "forRequest" })) {
                    enabled = false;
                }
                if (modelRef?.refInspectionTemp?.isInspectRiskValidated) {
                    enabled = false;
                }
                if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                return { disabled: enabled !== undefined ? !enabled : undefined };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "waitReceiveTitle",
                    "refInspectionTemp.isSampling",
                    "refInspectionTemp.abnormalRemark",
                    "refInspectionTemp.officerRemark",
                ].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                let result = false;
                const { menuContext } = props;
                if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                    if (![undefined, "draft", "reEditOfficer"].includes(modelRef.refStatus?.key)) {
                        result = true || result;
                    }
                }
                if (["approve"].includes(modelRef.refStatus?.key)) {
                    result = true || result;
                }
                return result;
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                    if (![undefined, "draft", "reEditOfficer"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                return { disabled: enabled !== undefined ? !enabled : undefined };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refInspectionTemp.refContactStaffType",
                ].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                let result = false;
                const { menuContext } = props;
                if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                    if (![undefined, "draft", "reEditOfficer"].includes(modelRef.refStatus?.key)) {
                        result = true || result;
                    }
                }
                if (["approve"].includes(modelRef.refStatus?.key)) {
                    result = true || result;
                }
                return result;
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                    if (![undefined, "draft", "reEditOfficer"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                if (modelRef.refInspectionTemp?.isRiskValidated && modelRef.refInspectionTemp?.isInspectRiskValidated) {
                    enabled = false;
                }
                return { disabled: enabled !== undefined ? !enabled : undefined };
            }
        },
        {
            check: ({ field }) => {
                return ["refInspectionTemp.unlockRemark",].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                let result = false;
                const { menuContext } = props;
                if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                    if (![undefined, "draft", "reEditOfficer"].includes(modelRef.refStatus?.key)) {
                        if (modelRef?.refInspectionTemp?.isUnlock) {
                            result = true || result;
                        }
                    }
                }
                if (["approve"].includes(modelRef.refStatus?.key)) {
                    result = true || result;
                }
                if (!modelRef?.refInspectionTemp?.isUnlock) {
                    result = false;
                }
                return result;
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refInspectionTemp.refInspectLocation",
                    "refInspectionTemp.refSequestrate",
                    "refInspectionTemp.locationRemark",
                ].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                let result = false;
                const { menuContext } = props;
                if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                    if (![undefined, "draft", "reEditOfficer"].includes(modelRef.refStatus?.key)) {
                        result = true || result;
                    }
                }
                if (["approve"].includes(modelRef.refStatus?.key)) {
                    result = true || result;
                }
                return result;
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                    if (![undefined, "draft", "reEditOfficer"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                if (!modelRef.refInspectionTemp?.isInspect) {
                    enabled = false;
                }
                return { disabled: enabled !== undefined ? !enabled : undefined };
            }
        },
        {
            check: ({ field }) => {
                return ["refInspectionTemp.refInspectDepartment"].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                let result = false;
                const { menuContext } = props;
                if (modelRef.refInspectionTemp?.refInspectLocation?.key === "1") {
                    if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                        if (![undefined, "draft", "reEditOfficer"].includes(modelRef.refStatus?.key)) {
                            result = true || result;
                        }
                    }
                    if (["approve"].includes(modelRef.refStatus?.key)) {
                        result = true || result;
                    }
                }
                return result;
            },
        },
        {
            check: ({ field }) => {
                return ["refInspectionTemp.refStorageLocation"].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                let result = false;
                const { menuContext } = props;
                if (modelRef.refInspectionTemp?.refInspectLocation?.key === "2") {
                    if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                        if (![undefined, "draft", "reEditOfficer"].includes(modelRef.refStatus?.key)) {
                            result = true || result;
                        }
                    }
                    if (["approve"].includes(modelRef.refStatus?.key)) {
                        result = true || result;
                    }
                }
                return result;
            },
        },
        {
            check: ({ field }) => {
                return ["InspectionOfficerList"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let result = false;
                if (modelRef.refInspectionTemp?.refContactStaffType?.key === "1") {
                    if (![undefined, "draft", "reEditOfficer"].includes(modelRef.refStatus?.key)) {
                        result = true || result;
                    }
                }
                return result;
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refInspectionTemp.refInformTemp.products.0.addresses.0.map",
                    "refInspectionTemp.refInformTemp.products.0.addresses.0.latitude",
                    "refInspectionTemp.refInformTemp.products.0.addresses.0.longitude",
                ].includes(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^refInspectionTemp\\.refInformTemp\\.products\\.[^\\.]+\\.isCheck$`, "g").test(field?.key);
            },
            visibleField: () => {
                return true;
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnlyInspection } = props;
                let enabled = false;
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                    enabled = !viewOnlyInspection || enabled;
                }
                if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                return { disabled: !enabled };
            },
        },
        {
            check: ({ field }) => {
                return new RegExp(`^refInspectionTemp\\.refInformTemp\\.products\\.[^\\.]+\\.(isSequestrate|isSampling)`, "g").test(field?.key);
            },
            visibleField: () => {
                return false;
            },
        },
        {
            check: ({ componentKey }) => {
                return new RegExp(`^SequestrateInfoForm`, "g").test(componentKey);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ componentKey }) => {
                return new RegExp(`^SamplingInfoForm`, "g").test(componentKey);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refInspectionTemp.attachments") &&
                    (field?.key?.endsWith("documentName") ||
                        field?.key?.endsWith("attribute.documentNo") ||
                        field?.key?.endsWith("attribute.documentDate") ||
                        field?.key?.endsWith("attribute.documentExpiredDate") ||
                        field?.key?.endsWith("size"))
                );
            },
            inputPropField: ({ modelRef, initialModel, record }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                        if (record?.attribute?.isDisabledDocumentName) {
                            common.disabled = true;
                        }
                    }
                }
                return common;
            }
        },
        {
            check: ({ componentKey }) => {
                return ["AttachmentInlineList"].includes(componentKey);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let canCreate = false;
                let canDelete = false;
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                return { canCreate, canDelete };
            }
        }
    ];
};
